import * as React from 'react'

import { Reorder } from 'framer-motion'

import styles from './index.module.scss'

interface Props<T> {
  items: T[]
  itemAsKey: (item: T, index: number) => string
  renderItem: (item: T, index: number) => JSX.Element
  isDisabled?: (item: T) => boolean
  trackingProperties?: Record<string, unknown> | undefined
  onReorder: (items: T[]) => void
}

function SortableLinkBoxList<T>({
  items,
  itemAsKey,
  renderItem,
  isDisabled,
  children,
  onReorder,
}: React.PropsWithChildren<Props<T>>) {
  if (children) return <>{children}</>

  return (
    <Reorder.Group axis="y" values={items} onReorder={onReorder} className={styles.list}>
      {items.map((item, index) => (
        <Reorder.Item
          key={itemAsKey(item, index)}
          value={item}
          className={styles.item}
          dragListener={isDisabled ? !isDisabled(item) : true}
        >
          {renderItem(item, index)}
        </Reorder.Item>
      ))}
    </Reorder.Group>
  )
}

export default SortableLinkBoxList
